import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Multimedia/Video_Overlays/SuccessBox';
import VideoOverlayTable from 'components/Web_User_Interface/1080p_Series/Multimedia/Video_Overlays/videoOverlayTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  VideoOverlayTable,
  BreadCrumbs,
  SEOHelmet,
  React
};